import { render, staticRenderFns } from "./supplierAdd.vue?vue&type=template&id=0295e2d0&scoped=true&"
import script from "./supplierAdd.vue?vue&type=script&lang=js&"
export * from "./supplierAdd.vue?vue&type=script&lang=js&"
import style0 from "./supplierAdd.vue?vue&type=style&index=0&id=0295e2d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0295e2d0",
  null
  
)

export default component.exports